import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import SearchSalefilesTable from "./searchSalefilesTable";

export default function SearchConfigPage() {
  return (
    <Switch>
      {
        <Redirect
          exact={true}
          from="/search"
          to="/search/searchSalefilesTable"
        />
      }
      <ContentRoute
        path="/search/searchSalefilesTable"
        component={SearchSalefilesTable}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
